export const cleanCurrency = (value: string) => value.replace("R$", "").trim(); // tira só o "R$" e espaços
